type VideoViewerProps = {
    src: string;
    rotation: number;
};

export const VideoViewer = ({ src, rotation }: VideoViewerProps) => (
    <video
        src={src}
        controls
        className="max-h-[70vh] max-w-full"
        style={{
            transform: `rotate(${rotation}deg)`,
            transition: 'transform 0.2s',
        }}
    />
);
